import Image from 'next/image'
import React from 'react'

import StudentWrokatAompany from '../assets/student-wrok-at-company.svg'

import SectionContent from './SectionContent'
import SectionHeader from './SectionHeader'
import SectionLayout from './SectionLayout'

const StudentWorkAtSection = () => {
  return (
    <div
      style={{
        background:
          'linear-gradient(126deg, rgba(97, 97, 214, 0.10) -0.76%, rgba(128, 128, 128, 0.10) 75.69%)'
      }}>
      <SectionLayout>
        <SectionHeader>
          Our Students <span className="text-primary">work at</span>
        </SectionHeader>
        <SectionContent>
          <Image
            src={StudentWrokatAompany.src}
            alt={''}
            width={200}
            height={100}
            className="max-w-7xl w-full h-full pt-10"
          />
        </SectionContent>
      </SectionLayout>
    </div>
  )
}

export default StudentWorkAtSection
